import { render } from "./component-select-shipment-id.vue?vue&type=template&id=4b00db5f&scoped=true&ts=true"
import script from "./component-select-shipment-id.vue?vue&type=script&lang=ts"
export * from "./component-select-shipment-id.vue?vue&type=script&lang=ts"

import "./component-select-shipment-id.vue?vue&type=style&index=0&id=4b00db5f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b00db5f"]])

export default __exports__